export default function(eventData) {
    let PointTotalService = require("../../../../service/quote/total/PointTotalService").default;
    eventData.service.totalCollectors.push({
        name: "rewardpoint",
        class: PointTotalService,
        sort_order: 410,
    });
}



// WEBPACK FOOTER //
// ./src/extension/reward-points/observer/service/quote/total/PointTotalServiceInit.js